import React from 'react';
import TextField from '@mui/material/TextField';

const IntegerField = ({ value, onChange, label, error, ...props }) => {
	const displayValue = value !== null && value !== undefined ? String(value) : "";

	const handleChange = (event) => {
		const input = event.target.value;
		if (/^\d*$/.test(input)) { // allow only digits
			if (onChange) {
				onChange(input !== "" ? parseInt(input, 10) : null);
			}
		}
	};

	return (
		<TextField
			variant="filled"
			size='small'
			// Remove MUI default background for filled inputs.
			sx={{
				'& input:focus': { border: 'none' },
				'& input': { border: 'none' },
				width: '100%'
			}}
			value={displayValue}
			onChange={handleChange}
			error={error}
			slotProps={{ htmlInput: { inputMode: 'numeric' },
			inputLabel: { shrink: false, sx: { transform: 'translate(12px, -6px) scale(0.75)' }} }}
			label={label}
			{...props}
		/>
	);
};

export default IntegerField;